import { useUserStore } from "@/store/modules/user";
import { useOidcStore } from "vue3-oidc";

export default () => {
  return async (to, from, next) => {
    const userStore = useUserStore();
    const oidcStore = useOidcStore();

    if (!userStore.getCurrentUser) {
      await userStore.fetchCurrentUser();
    }

    // Check if there's a saved redirect path from OIDC state
    const redirectPath = oidcStore.state.value?.user?.state?.redirectPath;
    if (redirectPath && redirectPath !== "/redirection") {
      return next({ path: redirectPath });
    }

    // If no redirect path, redirect based on user role
    const user = userStore.getCurrentUser;
    if (user.isRoleAdmin() || user.isRoleSuperAdmin()) {
      return next({ path: "/admin" });
    } else if (user.isRoleReviewer()) {
      return next({ path: "/reviewer" });
    } else {
      return next({ path: "/candidate" });
    }
  };
};
